export const en = {
    'annotation': 'When the call starts, you will be redirected to a video conference that will be available in the browser. The start time is indicated above',
    'unavailable-title': 'Call is unavailable',
    'unavailable-description': 'You don\'t have permission to access this call',
    'create-call': 'Create call',
    'today': 'Today',
    'tomorrow': 'Tomorrow',
}
